module.exports = __webpack_public_path__ + "static/media/hubpic1.aeae770d.jpg";